//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-autocomplete-input',
  props: {
    id: {
      type: String,
      default: '',
    },
    term: {
      type: String,
      default: '',
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Не задано',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    labelProperty: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showCode: {
      type: Boolean,
      default: false,
    },
    codeValue: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, Array, String],
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    inside: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeOpen (value) {
      this.$emit('change-open', value);
    },
    clean () {
      this.$emit('clean');
    },
    typeAheadSelect (e) {
      this.$emit('type-ahead-select', e);
    },
    delayedFocusout (e) {
      if (!this.inside) this.$emit('delayed-focusout', e);
    },
    focusin (e) {
      this.$emit('focusin', e);
    },
    inputFocus (e) {
      this.$emit('input-focus', e);
    },
    removeItem (e) {
      this.$emit('remove-item', e);
    },
    fillInput (e) {
      this.$emit('fill-input', e);
    },
  },
};
